// extracted by mini-css-extract-plugin
export default {"feedback":"FeedbackSurvey_feedback__CH5pS"};